import {Component, Input, OnInit} from '@angular/core';
import {BaseComponent, Position} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {PageLink} from './page-link.dto';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import {pageUrl} from '../routing/url-builder';

@Component({
    selector: 'page-link',
    templateUrl: './page-link.component.html',
    providers: [],
    imports: [RouterLink, AsyncPipe]
})
export class PageLinkComponent extends BaseComponent implements OnInit {
  /** Форму URL знает только билдер (ТЗ §6.3) — шаблону нужна функция. */
  readonly pageUrl = pageUrl;

  @Input() position: string;
  positions: Position;
  links$: Observable<PageLink[]>;

  ngOnInit() {
    let pos: Position = Position[this.position];

    if (pos == null) {
      console.log('Unknown position: ' + this.position);
    } else {
      let url = '/pages/links/' + pos;
      this.links$ = this.compoApiService.get<PageLink[]>(url).pipe(map(response => response.data));
    }
  }
}
